import { FLEXPORT_TRACKING_URL } from "parcel/constants";

export const generateFlexportTrackingUrl = (trackingCode) => {
  return `${FLEXPORT_TRACKING_URL}/${trackingCode}`;
};
